import { httpService } from '@dev.boon/brent';
import { FOSTER_API } from '@config/endpoints';

class MailService {
    async sendMail(type: string, to: string, name: string, mail: string, message: string) {
        try {
            const params = {
                type,
                to,
                metadata: {
                    fullName: name,
                },
                from: mail,
                message,
            };

            const { data: result } = await httpService.post(params, { url: FOSTER_API + '/messages' });

            return result;
        } catch (error) {
            throw error;
        }
    }
}

export const mailService = new MailService();
